import React from "react";

const GrowthOpportunities = () => {
  return (
    <div className="accordion-body">
      <div className="content">
        <div className="commitement-content">
          <p>
            We are focused on growing our operations organically by developing brownfield
            opportunities in our existing portfolio. Our large, well-diversified, low-cost and longlife
            asset portfolio offers us attractive expansion opportunities, which are evaluated
            based on our return criteria for long-term value creation for all stakeholders.
          </p>
        </div>

        <div className="commitement-content commitment-kits">
          <h5>KPIs</h5>
          <ul className="green-bullets">
            <li>Revenue</li>
            <li>ROCE</li>
            <li>FCF post-capex</li>
            <li>Growth capex</li>
          </ul>
        </div>

        <div className="commitement-content commitment-risks">
          <h5>Risks</h5>
          <ul className="green-bullets">
            <li>Major project delivery</li>
            <li>Cairn related challenges</li>
          </ul>
          <ul className="green-bullets">
            <li>Regulatory and legal risk</li>
          </ul>
        </div>

        <div className="commitement-content commitment-risks">
          <h5>FY2020 Update</h5>
          <h6>Oil & Gas</h6>
          <ul className="green-bullets">
            <li>
              Early gas production facility fully commissioned with ramped up volumes to ~127 mmscfd
            </li>
            <li>
              Won 10 exploratory blocks in OALP II & III
            </li>
            <li>
              To deliver the capex project, 235 wells have been drilled and 75 wells hooked up till FY2020
            </li>
          </ul>
          <ul className="green-bullets">
            <li>The addition of 10 blocks catapults us to become one of the largest private acreage holders in India, with a tenfold jump in acreage from its existing/
                producing blocks of ~6,000 sq km to ~65,000 sq km across its total 58 blocks
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default GrowthOpportunities;